import { firebasePublicConfig } from "../firebase/config";

function timeoutSignal(timeoutMs) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  return { controller, timer };
}

export async function checkFirebaseAuthReachability(timeoutMs = 5000) {
  const apiKey = (firebasePublicConfig.apiKey || "").trim();

  if (!apiKey) {
    return { ok: false, reason: "missing-api-key" };
  }

  const { controller, timer } = timeoutSignal(timeoutMs);

  try {
    const response = await fetch(
      `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${encodeURIComponent(apiKey)}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: "probe@example.com",
          password: "invalid-password",
          returnSecureToken: true,
        }),
        signal: controller.signal,
      }
    );

    clearTimeout(timer);

    if (response.status === 400 || response.status === 200) {
      return { ok: true, reason: "reachable" };
    }

    return { ok: false, reason: `http-${response.status}` };
  } catch (error) {
    clearTimeout(timer);
    if (error?.name === "AbortError") {
      return { ok: false, reason: "timeout" };
    }
    return { ok: false, reason: "network" };
  }
}

export function getFirebaseAuthTroubleshootingHint() {
  const hostname =
    typeof window !== "undefined" ? String(window.location.hostname || "").toLowerCase() : "";

  const domainHint = hostname
    ? `Add '${hostname}' to Firebase Authentication authorized domains.`
    : "Add your app domain to Firebase Authentication authorized domains.";

  return `${domainHint} Also verify API key/auth domain values in deployed environment.`;
}
